module.exports = __webpack_public_path__ + "./docs/img/icon-function.c176ff237e0ced26ecf827b21b3a30d2.svg";